import { styled as t } from "styled-components";
import { breakpoints as e } from "./atoms-v2125.js";
const o = t.table`
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
`, l = t.tr`
  height: 46px;

  @media ${e.medium} {
    height: 50px;
  }

  @media ${e.large} {
    height: 46px;
  }

  @media ${e.max} {
    height: 50px;
  }
`;
export {
  o as Table,
  l as TableHeadRow
};
